var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{staticClass:"opacity-0 absolute -z-1",attrs:{"id":"tabindex-drop-item","tabindex":"-1"}}),_vm._v(" "),_c('a',{staticClass:"skip-link fixed top-0 left-1/2 -translate-y-full -translate-x-1/2 focus:translate-y-0",attrs:{"href":"#main-content"}},[_vm._v("\n        "+_vm._s(_vm.$t('a11y.skip_to_main_content'))+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }